module.exports = __webpack_public_path__ + "img/Businessexploration.2ad71aae.svg";